import React from 'react'
import Chart from 'react-apexcharts'
import CircularProgress from '@material-ui/core/CircularProgress'
import config from '../config'

class GraphDetailContentComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      mounted: false,
      loading: true
    }
    this.options = this.getOption(props)

    this.series = [
      {
        name: 'Volume',
        data: props.data
      }
    ]
  }

  componentDidMount () {
    // Force chart to render after component is fully mounted
    setTimeout(() => {
      this.setState({ loading: false })
    }, 50)
  }

  componentWillReceiveProps (nextProps) {
    // Update data and options when props change
    if (nextProps.data !== this.props.data || nextProps.selectedDay !== this.props.selectedDay || nextProps.trbImm !== this.props.trbImm) {
      this.series[0].data = nextProps.data
      this.options = this.getOption(nextProps)
    }
  }

  getOption (props) {
    // Format date from selectedDay prop
    const dateText = props.selectedDay
      ? new Date(props.selectedDay).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })
      : ''

    // Get immatriculation from props
    const immatriculation = props.trbImm || ''

    return {
      annotations: {
        yaxis: [
          {
            y: props.tankCapacity + config.chartMaxVolumeMargin,
            borderColor: 'transparent',
            label: {
              borderColor: 'transparent',
              position: 'left',
              textAnchor: 'start',
              offsetX: 10,
              style: {
                color: 'rgb(54, 66, 72)',
                background: 'transparent',
                fontSize: '16px',
                fontWeight: 'bold'
              },
              text: `${dateText}`
            }
          },
          {
            y: props.tankCapacity + config.chartMaxVolumeMargin,
            borderColor: 'transparent',
            label: {
              borderColor: 'transparent',
              position: 'center',
              textAnchor: 'middle',
              style: {
                color: 'rgb(54, 66, 72)',
                background: 'transparent',
                fontSize: '16px',
                fontWeight: 'bold'
              },
              text: `${immatriculation}`
            }
          }
        ]
      },
      chart: {
        id: 'fuel-chart',
        animations: {
          enabled: false
        },
        width: '100%',
        height: '100%',
        toolbar: {
          show: true,
          tools: {
            pan: false
          },
          export: {
            csv: {
              filename: `fuel-chart-${immatriculation}`,
              columnDelimiter: ',',
              headerCategory: 'Date et Heure',
              headerValue: 'Volume (L)',
              dateFormatter (timestamp) {
                const date = new Date(timestamp)
                const dateStr = date.toLocaleDateString('fr-FR', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric'
                })
                const timeStr = date.toLocaleTimeString('fr-FR', {
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit'
                })
                return `${dateStr} ${timeStr}`
              }
            },
            png: {
              filename: `fuel-chart-${immatriculation}`
            },
            svg: {
              filename: `fuel-chart-${immatriculation}`
            }
          }
        },
        events: {
          // 🔥 FIX RESET
          beforeResetZoom: (ctx) => {
            const data = this.series[0].data

            if (!data || data.length === 0) return

            return {
              xaxis: {
                min: data[0].x,
                max: data[data.length - 1].x
              }
            }
          }
        }
      },
      grid: {
        show: true,
        borderColor: '#514141',
        strokeDashArray: 0,
        position: 'back',
        yaxis: {
          lines: {
            show: true
          }
        },
        xaxis: {
          lines: {
            show: true
          }
        }
      },
      xaxis: {
        axisBorder: {
          show: true,
          color: '#78909C'
        },
        axisTicks: {
          show: true,
          borderType: 'solid',
          color: '#78909C',
          width: 6,
          offsetX: 0,
          offsetY: 1
        },
        type: 'datetime',
        title: {
          text: 'HEURE',
          offsetY: 5,
          style: {
            color: 'black'
          }
        },
        labels: {
          style: {
            colors: 'black'
          },
          datetimeUTC: false,
          datetimeFormatter: {
            hour: 'HH:mm'
          }
        }
      },
      yaxis: {
        axisBorder: {
          show: true,
          color: '#78909C'
        },
        axisTicks: {
          show: true,
          borderType: 'solid',
          color: '#78909C',
          width: 6,
          offsetX: 0,
          offsetY: 1
        },
        labels: {
          style: {
            colors: 'black',
          },
          formatter: function(value) {
            var val = Math.round(value);
            return val + " L"
          }
        },
        title: {
          text: 'VOLUME CARBURANT',
          style: {
            color: 'black'
          }
        },
        min: 0,
        max: (props.tankCapacity + config.chartMaxVolumeMargin)
      },
      tooltip: {
        x: {
          show: true,
          format: 'dd MMM HH:mm'
        }
      },
      stroke: {
        show: true,
        curve: 'straight',
        lineCap: 'round',
        width: 3.5
      }
    }
  }

  render () {
    const self = this

    if (self.state.loading) {
      return <CircularProgress style={styles.circularProgressStyle} color='inherit' />
    }

    return (
      <div style={styles.container}>
        <div style={styles.content}>
          <Chart
            type='line'
            options={this.options}
            series={this.series}
          />
        </div>
      </div>
    )
  }
}

const styles = {
  container: {
    marginTop: '22px',
    padding: '8px',
    width: '100%',
    height: '640px',
    borderRadius: '3px',
    backgroundColor: '#364248'
  },
  content: {
    height: '566px',
    marginTop: '12px'
  },
  circularProgressStyle: {
    color: '#7ED321',
    marginLeft: '428px',
    marginTop: '154px',
    marginBottom: '474px'
  }
}

export default GraphDetailContentComponent
